// src/components/Honeypot.jsx
import React from 'react';

const Honeypot = () => (
  <div
    aria-hidden="true"
    style={{
      position: 'absolute',
      left: '-10000px',
      top: 'auto',
      width: '1px',
      height: '1px',
      overflow: 'hidden',
    }}
  >
    <label>
      Enter your id:
      <input name="hp_field" autoComplete="off" tabIndex="-1" />
    </label>
  </div>
);

export default Honeypot;

